import { localStorageStores } from 'state/localStorageStores';
import { isProduction } from './misc';

export const log = (message?: any, ...optionalParams: any[]) => {
  if (isProduction() && !localStorageStores.betaFeatures.areBetaFeaturesEnabled) return;

  console.log(message, ...optionalParams);
};
